import service from '../request'
const baseUrl = window.globalUrl.HOME_API;

/**
 * 供应订单列表
 */
export const getSupplyOrderList = (params) => {
  return service({
    method: 'get',
    url: `${baseUrl}/trade-website/supplyOrder/list`,
    params: params
  })
}

/**
 * 供应订单详情
 */
export const getSupplyOrderDetail = (params) => {
  return service({
    method: 'get',
    url: `${baseUrl}/trade-website/supplyOrder/detail`,
    params: params
  })
}

/**
 * 新增供应订单
 */
export const addSupplyOrder = (params) => {
  return service({
    method: 'post',
    url: `${baseUrl}/trade-website/supplyOrder/add`,
    data: params
  })
}

/**
 * 修改供应订单
 */
export const editSupplyOrder = (params) => {
  return service({
    method: 'post',
    url: `${baseUrl}/trade-website/supplyOrder/edit`,
    data: params
  })
}

/**
 * 删除供应订单
 */
export const deleteSupplyOrder = (params) => {
  return service({
    method: 'post',
    url: `${baseUrl}/trade-website/supplyOrder/delete`,
    params: params
  })
}

/**
 * 产品种类分级列表
 */
export const getProductCategoryTree = (params) => {
  return service({
    method: 'get',
    url: `${baseUrl}/trade-website/supplyProductCategory/tree`,
    params: params
  })
}
